import {
  Shield,
  Play,
  UserPlus,
  Settings,
  Calendar,
  FileText,
  Activity,
  ListChecks,
  CreditCard,
} from "lucide-react";
import type { ComponentType } from "react";
import type { Action, ActionId } from "./types";

export const ACTIONS_CATALOG: ReadonlyArray<Action> = [
  { id: "workers_comp", label: "Add workers comp", route: "/payroll/settings" },
  { id: "run_payroll", label: "Run payroll", route: "/payroll/run" },
  { id: "add_employee", label: "Add employee", route: "/payroll/employees/add" },
  { id: "update_settings", label: "Update payroll settings", route: "/payroll/settings" },
  { id: "edit_items", label: "Edit payroll items", route: "/payroll/settings" },
  { id: "work_location", label: "Update work location", route: "/payroll/settings" },
  { id: "accounting_prefs", label: "Update accounting preferences", route: "/payroll/settings" },
  { id: "paycheque_list", label: "View paycheque list", route: "/payroll/paycheques" },
  { id: "off_cycle", label: "Run off-cycle payroll", route: "/payroll/run" },
  { id: "direct_deposit", label: "Set up direct deposit", route: "/payroll/settings" },
  { id: "pay_schedule", label: "Manage pay schedule", route: "/payroll/settings" },
];

type IconComponent = ComponentType<{ size?: number | string }>;

export const ACTION_ICONS: Record<ActionId, IconComponent> = {
  workers_comp: Shield,
  run_payroll: Play,
  add_employee: UserPlus,
  update_settings: Settings,
  edit_items: FileText,
  work_location: Calendar,
  accounting_prefs: Activity,
  paycheque_list: ListChecks,
  off_cycle: Play,
  direct_deposit: CreditCard,
  pay_schedule: Calendar,
};

export const SCHEDULE_LABELS: Record<string, string> = {
  weekly: "Weekly",
  bi_weekly: "Bi-weekly",
  biweekly: "Bi-weekly",
  semi_monthly: "Semi-monthly",
  monthly: "Monthly",
};

export const DEFAULT_FAVOURITES: ActionId[] = [
  "workers_comp",
  "run_payroll",
  "add_employee",
  "update_settings",
];

export const MAX_FAVOURITES = 10;
export const FAVOURITES_STORAGE = "novala_create_action_favourites";

export interface CountryOption {
  code: string;
  iso: string;
  name: string;
}

export const COUNTRIES_TYN: ReadonlyArray<CountryOption> = [
  { code: "US", iso: "us", name: "United States" },
  { code: "CA-EN", iso: "ca", name: "Canada (English)" },
  { code: "CA-FR", iso: "ca", name: "Canada (Français)" },
  { code: "GB", iso: "gb", name: "United Kingdom" },
  { code: "AU", iso: "au", name: "Australia" },
  { code: "NZ", iso: "nz", name: "New Zealand" },
  { code: "SG", iso: "sg", name: "Singapore" },
  { code: "JP", iso: "jp", name: "Japan" },
  { code: "DE", iso: "de", name: "Germany" },
  { code: "FR", iso: "fr", name: "France" },
  { code: "ZA", iso: "za", name: "South Africa" },
  { code: "OTHER", iso: "un", name: "Other country" },
];